import React from 'react'
import * as s from './sideModal.module.css'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

interface SideModalProps {
    title: string,
    text: string,
    position?: 'left' | 'right',
    width?: number | string,
    closeFunction?: any,
};

const SideModal: React.FC<SideModalProps> = ({ title, text, position, width = '45%', closeFunction }) => {
    return (
        <div className={`${ s.modal } ${ s[ position || 'left']}`}>
            <div
                className={ s.content }
                style={{ width }}
            >
                <div className={ s.header }>
                    <span>{ title }</span>

                    <div
                        className={ s.close }
                        onClick={ closeFunction && closeFunction }
                    >
                        <FontAwesomeIcon className={s.check} icon={faTimes} color="#FFF" />
                    </div>
                </div>

                <div className={ s.body }>
                    <span>{ text }</span>
                </div>
            </div>
        </div>
    );
};

export {SideModal}